export interface PermissionState {
    permissions: string[]; // Permissions are stored as a string array
}

export const initialPermissionState: PermissionState = {
    permissions: [],
};
